<template>
  <b-form-row>
    <lg-finder ref="finder" :id="this.id" :fields="fields" title="Busca de Tipo Documento" filterBy="descricao"
      url="/api/tipo-documento"  @onSelect="onSelect" filtrarSituacao />
  </b-form-row>

</template>

<script>
import LgFinder from "@/core/components/Inputs/LgFinder.vue";
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";

export default {

  components: { LgFinder, LgFormInputFinder },

  props: {
    id: String,
  },

  data() {
    return {

      fields: [
        {
          key: "descricao",
          label: "Descrição",
          thClass: "pt-1 pb-0",
          tdClass: "py-0 text-center col-1",
        },

        {
          key: "situacao",
          label: "Situaçào",
          thClass: "pt-1 pb-0",
          tdClass: "py-0 text-center col-1",
        },

      ],
    };
  },
  methods: {
    async show() {
      await this.$refs.finder.show();
    },
    async onSelect(item) {
      this.$emit("onSelect", item);
      await this.$bvModal.hide(this.id);
    },
  },
};
</script>
